module.exports = __webpack_public_path__ + "static/media/Send_Message_Icon@3x.b0f371b6.png";